import { BookableType, type IBookableItemsFilter } from "@app/common/types";

import { getShortId } from "../ids/generateIds";

export const setFilterUrlParams = (params: URLSearchParams, filter: IBookableItemsFilter) => {
    if (filter) {
        const type = filter.type === undefined ? null : filter.type === "rp" ? "rp" : filter.type === BookableType.Room ? "r" : "p";

        if (type) {
            params.set("f[type]", type);
        } else {
            params.delete("f[type]");
        }

        if (filter.filters.length) {
            params.set("f[filters]", filter.filters.map((id) => getShortId(id)).join(","));
        } else {
            params.delete("f[filters]");
        }
    }
};
